import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function IniziamoLaTrasformazione() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="28838" id="inizia-la-collaborazione" className="dark bg-background text-foreground relative overflow-hidden py-24 md:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
        <div className="h-[500px] w-[500px] rounded-full bg-[radial-gradient(circle,var(--color-primary)_0%,transparent_70%)] opacity-10 blur-3xl md:h-[800px] md:w-[800px] md:opacity-15" />
      </div>

      <div ref={ref} className={`container relative z-10 mx-auto px-4 text-center transition-all duration-1000 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
        <h2 className="mb-10 text-3xl font-bold tracking-tighter md:text-4xl lg:text-5xl">Serve supporto per le tecnologie della tua azienda?</h2>

        <div className="flex justify-center">
          <Link to="/ContactsPage">
            <Button size="lg" className="group relative h-14 rounded-sm bg-primary px-8 text-lg font-semibold text-primary-foreground transition-all duration-300 hover:scale-105 hover:bg-primary/90 hover:shadow-[0_0_30px_-5px_rgba(6,182,212,0.6)]">
              Richiedi una consulenza
              <ArrowRight className="ml-2 size-5 transition-transform duration-300 group-hover:translate-x-1" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}